(function (angular) {
	'use strict';

	var accountValueChartObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			placeholderMessage: '<',
			theme: '@'
		},
		controller: [
			'$filter',
			'INVESTMENT_ENTITY_ID',
			'urlFactory',
			AccountValueChartFunction
		],
		controllerAs: 'accountValueChart'
	};

	angular
		.module('investorDashboard')
		.component('accountValueChart', accountValueChartObject);

	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/investor-dashboard/account-value-chart.html';
	}

	function AccountValueChartFunction(
		$filter,
		INVESTMENT_ENTITY_ID,
		urlFactory) {
		
		var accountValueChart = this;
		accountValueChart.showChart = true;
		var chart;

		accountValueChart.$onInit = function(changesObj){
			urlFactory.apiGetPromise('/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID +'/performance/account-value-over-time').then(
				function(response) {
					if(response.data.length > 7) {
						initChart(response.data);
					} else {
						accountValueChart.showChart = false;
					}
				}, function(response) {
					accountValueChart.showChart = false;
				});
		};

		function initChart(responseData){
			var data = [];
			var yAxisMax = 0;
			var startDate = new Date(responseData[0].date).getTime();

			angular.forEach(responseData, function(entry) {

				var totalAccountValuePlusPendingOrders = parseFloat(entry.totalAccountValuePlusPendingOrders);
				var chartDataPoint = totalAccountValuePlusPendingOrders;
				
				if(totalAccountValuePlusPendingOrders > yAxisMax) {
					yAxisMax = totalAccountValuePlusPendingOrders;
				}

				data.push(chartDataPoint);
			});

			var currencyFraction = yAxisMax > 5000 ? 0 : 2;

			var chartOptions = {
				chart: {
					type: 'area'
				},
				series: [{
					name: 'Account value',
					data: data,
					pointInterval: 24 * 3600 * 1000,
					pointStart: startDate,
					states: {
						hover: {
							enabled: true
						}
					}
				}],
				tooltip: {
					crosshairs: true,
					enabled: true,
					formatter: function() {
						return '<span class="eta display-block body-text-color text-align-center">' + $filter('date')(this.x, 'MMM d, yyyy') + '</span><span class="zeta display-block heading-text-color font-weight-bold text-align-center">' + $filter('currency')(this.y, '$', 2) + '</span>';
					}
				},
				xAxis: {
					dateTimeLabelFormats: {
						day: '%b %e',
						week: '%b %e'
					},
					type: 'datetime'
				},
				yAxis: {
					labels: {
						formatter: function() {
							return $filter('currency')(this.value, '$', currencyFraction);
						}
					},
					floor: 0
				},
				responsive: {
					rules: [{
						condition: {
							minWidth: 480
						},
						chartOptions: {
							tooltip: {
								positioner: function(labelWidth, labelHeight, point) {
									var coords = {
										x: this.chart.plotLeft + point.plotX - (labelWidth / 2),
										y: this.chart.plotTop + point.plotY - labelHeight - 16
									};
									return coords;
								}
							}
						}
					}]
				}
			};

			if(accountValueChart.theme === 'dark') {
				chartOptions.series[0].color = 'hsl(210,100%,80%)';
			}

			accountValueChart.chartOptions = chartOptions;
		}
	}
})(window.angular);